import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import ReactEchart from '../../../../../../components/common/ReactEchart';
import * as echarts from 'echarts/core';
import {
    TitleComponent,
    TooltipComponent,
    GridComponent,
    LegendComponent
} from 'echarts/components';
import { BarChart } from 'echarts/charts';
import { CanvasRenderer } from 'echarts/renderers';
import { useAppContext } from '../../../../../../providers/AppProvider';
import { rgbaColor } from '../../../../../../helpers/utils';
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import "dayjs/locale/es";

dayjs.extend(customParseFormat)
dayjs.locale("es")

echarts.use([
    TitleComponent,
    TooltipComponent,
    GridComponent,
    BarChart,
    CanvasRenderer,
    LegendComponent
]);

const KilometrajeChart = ({ setUserCount, data }) => {
    const chartRef = useRef(null);
    const { getThemeColor } = useAppContext();

    const [kmData, setKmData] = useState(data.map(d => d.kilometros));
    const [axisData, setAxisData] = useState(data.map(d => d.fecha));

    useEffect(() => {
        if (data.length > 0) {
            const kms = data.map(d => d.kilometros);
            setKmData(kms);
            setAxisData(data.map(d => d.fecha));
            setUserCount(kms.reduce((total, val) => total + val, 0));
        }
    }, [data, setUserCount]);

    const maxKm = Math.max(...kmData);

    return (
        <ReactEchart
            ref={chartRef}
            echarts={echarts}
            option={{
                tooltip: {
                    trigger: 'axis',
                    padding: [7, 10],
                    axisPointer: { type: 'shadow' },
                    backgroundColor: getThemeColor('gray-100'),
                    borderColor: getThemeColor('gray-300'),
                    textStyle: { color: getThemeColor('gray-1100') },
                    borderWidth: 1,
                    transitionDuration: 0,
                    formatter: params => {

                        const _fecha = dayjs(params[0].axisValueLabel);

                        return `<div>
                            <h6 class="fs-10 text-700 mb-0 d-flex align-items-center">
                                <div class="dot me-1" style="background-color:${getThemeColor('primary')}"></div>
                                ${_fecha.format('D')} ${_fecha.format('MMMM')}: ${params[0].value} km
                            </h6>
                        </div>`
                    }
                },
                xAxis: {
                    type: 'category',
                    axisLabel: {
                        color: getThemeColor("gray-400"),
                        rotate: axisData.length > 5 ? 45 : 0,
                        //formatter: val => `${val} km`,
                        formatter: (value) => {

                            const fecha = dayjs(value);
                            const dias = ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa'];
                            const diaSemana = dias[fecha.day()];
                            return `${diaSemana} ${fecha.format("DD MMM")}`;
                        }
                    },

                    axisTick: { show: false },
                    axisLine: { show: false },
                    boundaryGap: true,
                    data: axisData
                },
                yAxis: {
                    type: 'value',
                    scale: true,
                    boundaryGap: false,
                    axisLabel: {
                        show: true,
                        color: getThemeColor("gray-400"),
                        margin: 15,
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            type: 'dashed',
                            color: getThemeColor('gray-300')
                        }
                    }
                },
                series: [
                    {
                        type: 'bar',
                        barCategoryGap: '10%',
                        barWidth: '90%',
                        data: kmData,
                        lineStyle: { color: getThemeColor("primary") },
                        itemStyle: {
                            borderColor: getThemeColor("primary"),
                            borderWidth: 2,
                            backgroundColor: "transparent",
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                { offset: 0, color: getThemeColor('primary') || '#4e73df' },
                                { offset: 1, color: getThemeColor('primary-light') || '#74a6f5' }
                            ])
                        },
                        animation: false // **Deshabilita animación**
                    }
                ],
                grid: { left: 50, right: 10, bottom: 50, top: 10 }
            }}
            style={{ width: '100%', height: '80%' }}
        />
    );
};

KilometrajeChart.propTypes = {
    setUserCount: PropTypes.func.isRequired,
    data: PropTypes.arrayOf(
        PropTypes.shape({
            fecha: PropTypes.string.isRequired,
            kilometros: PropTypes.number.isRequired
        })
    ).isRequired
};

export default KilometrajeChart;
